/**
 * Dekoduje encje HTML w tekstach, które trafiają do widoku przez interpolację `{{ }}` — tam Angular
 * wypisałby `&amp;` dosłownie. Treści renderowane przez `[innerHTML]` (CKEditor + `jsonToHtml`)
 * NIE powinny przez to przechodzić — przeglądarka rozwiąże im encje sama.
 *
 * `&amp;` zamieniamy na końcu, żeby podwójnie zakodowane wejście (`&amp;lt;`) rozkodowało się
 * tylko o jeden poziom (do `&lt;`), a nie do surowego `<`.
 */
export function decodeHtmlEntities(str: string): string {
  if (typeof str !== 'string') return str;
  return str
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&(?:apos|#0*39);/g, "'")
    .replace(/&nbsp;/g, '\u00A0')
    .replace(/&amp;/g, '&');
}
